import { render, staticRenderFns } from "./MockTest.vue?vue&type=template&id=64636fc0&scoped=true&"
import script from "./MockTest.vue?vue&type=script&lang=js&"
export * from "./MockTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64636fc0",
  null
  
)

export default component.exports